export function normalizeFlightNumberSuggestionValue(value) {
    return String(value || "").trim().toUpperCase();
}

export function buildFlightNumberSuggestionKey(aircraftReg, dep, arr) {
    const parts = [aircraftReg, dep, arr].map(normalizeFlightNumberSuggestionValue);
    if (parts.some((part) => !part)) {
        return "";
    }
    return parts.join(":");
}

export function buildFlightNumberSuggestionPair(aircraftReg, dep, arr) {
    const pair = {
        aircraft_reg: normalizeFlightNumberSuggestionValue(aircraftReg),
        dep: normalizeFlightNumberSuggestionValue(dep),
        arr: normalizeFlightNumberSuggestionValue(arr),
    };
    if (!pair.aircraft_reg || !pair.dep || !pair.arr) {
        return null;
    }
    return pair;
}

export function buildFlightNumberSuggestionPairs(rows = []) {
    const pairsByKey = new Map();

    rows.forEach((row) => {
        const flight = row?.rawFlight;
        const pair = buildFlightNumberSuggestionPair(flight?.aircraft_reg, flight?.departure_airport, flight?.arrival_airport);
        const key = pair ? buildFlightNumberSuggestionKey(pair.aircraft_reg, pair.dep, pair.arr) : "";
        if (!key || pairsByKey.has(key)) {
            return;
        }

        pairsByKey.set(key, pair);
    });

    return Array.from(pairsByKey.entries())
        .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))
        .map(([, pair]) => pair);
}

export function buildFlightNumberSuggestionMap(response) {
    const suggestions = new Map();

    (response?.pairs || []).forEach((item) => {
        const flightNumber = String(item?.suggested_flight_number || "").trim();
        const key = buildFlightNumberSuggestionKey(item?.aircraft_reg, item?.dep, item?.arr);
        if (key && flightNumber) {
            suggestions.set(key, flightNumber);
        }
    });

    return suggestions;
}
